import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { useTimeZone } from '../../../hooks'
import { Status, STATUS_SIZE_16 } from '../../Status'
import { LISTING_ALREADY_PUBLISHED_TEXT_COLOR } from '../RentalPortalListing.constants'
import { getListingAlreadyPublishedTooltip } from '../RentalPortalListing.utils'

function RentalPortalListingAlreadyPublishedChip({
  className,
  flatPublishedListing,
}) {
  const { t } = useTranslation()

  const timezone = useTimeZone()

  return (
    <Status
      className={className}
      height={STATUS_SIZE_16}
      text={t('RentalPortal.ListingAlreadyPublishedKey')}
      textColor={LISTING_ALREADY_PUBLISHED_TEXT_COLOR}
      tooltip={getListingAlreadyPublishedTooltip({
        flatPublishedListing,
        t,
        timezone,
      })}
      tooltipPlacement={FLOATING_ELEMENT_PLACEMENT.top}
    />
  )
}

export default RentalPortalListingAlreadyPublishedChip
